export const PARTICIPATION_EMPLOYEUR = 7.0;
export const CSG_CRDS = 1 - 0.2 * 0.097;
